<template>
  <div>
    <label v-if="label" class="label-input">{{ label }}</label>
    <div :class="['group-item', wrapperClass]">
      <v-row class="mt-2">
        <v-col md="2" cols="12">
          <v-checkbox
            :input-value="safeAccordion.open"
            label="Default Open"
            class="mt-0"
            @change="value => updateAccordion('open', !!value)"
          />
        </v-col>
        <v-col md="5" cols="12">
          <ColorPicker
            name="accordionPrimaryBackgroundColor"
            default-color="#000000"
            :value="safeAccordion.backgroundColor"
            label="Background Color"
            @input="value => updateAccordion('backgroundColor', value)"
          />
        </v-col>
        <v-col md="5" cols="12">
          <ColorPicker
            name="accordionPrimaryColor"
            default-color="#ffffff"
            :value="safeAccordion.color"
            label="Text Color"
            @input="value => updateAccordion('color', value)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-checkbox
            :input-value="safeAccordion.icon.show"
            label="Show Icon"
            hide-details
            class="mt-0"
            @change="value => updateAccordionIcon('show', !!value)"
          />
        </v-col>
        <v-col md="5" cols="12">
          <v-select
            :value="safeAccordion.icon.type"
            :items="iconTypeItems"
            item-text="text"
            item-value="value"
            label="Icon Type"
            hide-details
            dense
            @change="value => updateAccordionIcon('type', value)"
          />
        </v-col>
        <v-col md="5" cols="12">
          <v-select
            :value="safeAccordion.icon.position"
            :items="iconPositionItems"
            label="Icon Position"
            hide-details
            dense
            @change="value => updateAccordionIcon('position', value)"
          />
        </v-col>
      </v-row>
      <div class="mt-4">
        <div class="mb-1">Title</div>
        <ckeditor
          :editor="editor"
          :value="safeAccordion.title"
          :config="editorConfig"
          @input="v => updateAccordion('title', v)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import ColorPicker from './color-picker.vue';

const defaultAccordion = {
  open: true,
  title: '<h2><strong>Accordion Title</strong></h2>',
  backgroundColor: '#000000',
  color: '#ffffff',
  icon: {
    type: 'plus-minus',
    position: 'right',
    show: true,
  },
};

export default {
  name: 'AccordionPrimary',
  components: {
    ColorPicker,
  },
  props: {
    accordion: {
      type: Object,
      required: true,
      default: () => ({ ...defaultAccordion }),
    },
    label: {
      type: String,
      default: 'Accordion Primary',
    },
    wrapperClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      iconTypeItems: [
        { text: 'Plus / Minus', value: 'plus-minus' },
        { text: 'Chevron Down / Up', value: 'chevron-down-up' },
        { text: 'Plus / Close', value: 'plus-close' },
      ],
      iconPositionItems: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
    };
  },
  computed: {
    uid() {
      return `accordion-primary-${this._uid}`;
    },
    safeAccordion() {
      return {
        ...defaultAccordion,
        ...(this.accordion || {}),
        icon: {
          ...defaultAccordion.icon,
          ...((this.accordion && this.accordion.icon) || {}),
        },
      };
    },
  },
  methods: {
    updateAccordion(key, value) {
      this.$set(this.accordion, key, value);
      this.$emit('update:accordion', this.accordion);
      this.$emit('change', this.accordion);
    },
    updateAccordionIcon(key, value) {
      if (!this.accordion.icon || typeof this.accordion.icon !== 'object') {
        this.$set(this.accordion, 'icon', { ...defaultAccordion.icon });
      }
      this.$set(this.accordion.icon, key, value);
      this.$emit('update:accordion', this.accordion);
      this.$emit('change', this.accordion);
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
</style>
